
window.Vivense = window.Vivense || {};

// MooTools conflicts with bootstrap, causing the inputs to disappear. See
// https://github.com/mootools/mootools-more/issues/1127  and
// https://github.com/twbs/bootstrap/issues/3436
if (window.addEvent && MooTools) {
    (function($) {
        window.addEvent('domready', function() {
            $$('#loginPopup .input-group, #headerMyAccount .user-menu-container').each(function (e) {
                // remove the hide function so they don't disappear
                // e.hide = null;
            });
        });

    })(MooTools);
}

Vivense.popupAction = null;
Vivense.popupScenario = "";

Vivense.loginPopup = (function($) {

    var exports = {}, popup, form, afterSuccessFunc, allButtons, loading, kvkkpopup, commercialEmailPopup;

    function open(fromAction, scenario) {

        clearAllValidation();

        $(".failed-login-wrapper").removeClass("failed-login");
        $(".failed-login-wrapper-password").removeClass("failed-login-password");
        $(".login-email-input").removeClass("validation-failed");
        $(".login-password-input").removeClass("validation-failed");

        Vivense.popupAction = fromAction;

        if (scenario === undefined){
            scenario = "";
        }
        Vivense.popupScenario = scenario;

        popup.modal();

        $(".modal-backdrop").addClass("user-popup");
    }

    function openFavoritesPopup(){
        if(parseInt(window.userId) > 0 ){
            $(".my-favorites-container").attr("href", "/favorilerim.html?ref=header_icon");
            $(".headerMyFavoriteLink").attr("href", "/favorilerim.html?ref=header_icon");
        }
        window.location.href = "/vivense-uye-girisi.html?ref=header_icon"
    }

    function openWithCallback(successFunc) {
        if (successFunc) {
            afterSuccessFunc = successFunc;
        } else {
            afterSuccessFunc = null;
        }

        open();
    }

    function close() {
        popup.modal('hide');

    }

    function onClose(funct) {
        popup.on('hidden.bs.modal', function (event) {
            event.stopImmediatePropagation();
            funct();
            popup.on('hidden.bs.modal').off();
        });
    }

    function genericError() {
        enableAllButtons();
        Vivense.validateError('Bir hata oluştu, lütfen tekrar deneyin.');
    }

    function displayLoginError(data) {
        enableAllButtons();
        Vivense.validateError(data.error, data.errorCode);
    }

    function gtaEvent(){
        dataLayer.push({
            'Category':'Membership',
            'Action':'Login',
            'Label':' Successful / Manuel',
            'event':'gaEvent'
        });


    }

    function relatedEvent(key){
        dataLayer.push({
            event: "vlEvent",
            vl_label: "VL-Login",
            vl_userID:key
        });
    }

    function pushFormErrorGtaEvent(message){
        dataLayer.push({
            'Category':'Membership',
            'Action':'Login Error',
            'Label': message,
            'event':'gaEvent'
        });
    }

    function finishSuccessfulLogin(data) {
        afterSuccessFunc = function () {
            window.location = data.redirectURL;
        };
        Vivense.populate.insertEvent(Vivense.popupScenario, window.currentPage, Vivense.popupAction, "membership", 1, afterSuccessFunc);
    }

    function handleEmailLoginResult(data, textStatus, jqXHR) {
        if ( ! data.success) {
            displayLoginError(data);
            pushFormErrorGtaEvent(data.error);
            return;
        }

        gtaEvent();
        relatedEvent(data.email);
        finishSuccessfulLogin(data);
    }

    function getLoginForm() {
        return form;
    }

    function disableAllButtons() {
        $('button').prop('disabled', true);
        loading.show();
    }

    function enableAllButtons() {
        $('button').prop('disabled', false);
        loading.hide();
    }

    function addStandardParameters(formData) {
        formData.push({
            name : 'return-type',
            value : 'json'
        });
        formData.push({
            name : window.formToken,
            value : '1'
        });
    }

    function submitForm(e) {

        e.preventDefault();

        $(".failed-login-wrapper").removeClass("failed-login");
        $(".failed-login-wrapper-password").removeClass("failed-login-password");
        $(".login-email-input").removeClass("validation-failed");
        $(".login-password-input").removeClass("validation-failed");

        if (!userPopupActionValidation(form)) {

            var emailValidationEl = $(".email-validation");
            var passwordValidationEl = $(".password-validation");

            if(emailValidationEl.length && emailValidationEl.text()){
                pushFormErrorGtaEvent(emailValidationEl.text());
            }

            if (passwordValidationEl.length && passwordValidationEl.text()){
                pushFormErrorGtaEvent(passwordValidationEl.text());
            }

            return false;
        }

        disableAllButtons();

        var formData = form.serializeArray();
        addStandardParameters(formData);

        e.preventDefault();

        $.post(form.attr('action'), $.param(formData))
            .done(handleEmailLoginResult)
            .fail(genericError);

    }



    function logout(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        $.get(url).done(function() {
            // check session is called to re-initialize the new session
            $.get('/checkSession.php').done(function () {
                window.location = '/';
            });
        });
    }

    function contractConfirmation(){
        var confirmCheckBox = popup.find('#confirm-contract');
        confirmCheckBox.prop( "checked", true );
        kvkkpopup.modal('hide');
    }

    function commercialEmailAllow(){
        var allowCheckBox = popup.find('#allow_communication');
        allowCheckBox.prop( "checked", true );
        commercialEmailPopup.modal('hide');
    }


    function init() {

        popup = $('#loginPopup');
        kvkkpopup = $('#kvkkpopup');
        commercialEmailPopup = $('#ticari');

        // Close Modal Populate
        if (window.currentPage === "cartOrderFinal"){
            popup.on('hidden.bs.modal', function () {
                Vivense.populate.insertEvent("softRegistration", window.currentPage, "self", "softRegistration", 0);
            });
        } else {
            popup.on('hidden.bs.modal', function () {
                Vivense.populate.insertEvent(Vivense.popupScenario, window.currentPage, Vivense.popupAction, "membership", 0);
                $('#registrationForm .inner-center-mod .favorites-text').hide();
                $('#registrationForm .inner-center-mod .login-text').hide();
                $("#registrationForm .inner-center-mod .short-desc").show();
            });
        }

        form = $('#loginForm');
        form.on('submit', submitForm);

        var contractConfirmationButton = kvkkpopup.find("#contract_confirmation");
        contractConfirmationButton.on('click',contractConfirmation);

        var commercialEmailAllowButton = commercialEmailPopup.find("#commercial_email_allow");
        commercialEmailAllowButton.on('click',commercialEmailAllow);


        allButtons = popup.find('button');
        loading = popup.find('.loading');
        //$('#logoutLink').click(logout);
    }

    $(document).ready(init);

    exports.open = open;
    exports.openFavoritesPopup = openFavoritesPopup;
    exports.openWithCallback = openWithCallback;
    exports.close = close;
    exports.onClose = onClose;
    exports.getLoginForm = getLoginForm;
    exports.finishSuccessfulLogin = finishSuccessfulLogin;
    exports.displayLoginError = displayLoginError;

    exports.enableAllButtons = enableAllButtons;
    exports.disableAllButtons = disableAllButtons;
    exports.addStandardParameters = addStandardParameters;

    return exports;

})(jQuery);
